import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-sort',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.scss'],
    standalone: false
})
export class SortComponent {

  public state = false;
  @Output() sortChanged = new EventEmitter();

  constructor() { }

  public toggleState() {
    this.state = !this.state;
    this.sortChanged.emit(this.state);
  }

}
